export default "__VITE_ASSET__DML0Mjag__"